// eslint-disable-next-line no-unused-vars
import GenerateOverdueInvoiceChargesResult from '@/models/finance/generateOverdueInvoiceChargesResult'
// eslint-disable-next-line no-unused-vars
import GenerateOverdueInvoiceChargesDTO from '@/models/finance/generateOverdueInvoiceChargesDTO'
// eslint-disable-next-line no-unused-vars
import OverdueInvoicesByClientInvoiceViewModel from '@/models/finance/overdueInvoicesByClientInvoiceViewModel'
// eslint-disable-next-line no-unused-vars
import InvoiceCenterViewModel from '@/models/finance/invoiceCenterViewModel'

import { ModelApiService } from './BaseApiService'

export default class FinanceApiService extends ModelApiService {
  constructor() {
    super('finance')
  }

  /**
   * Retrieves Invoice Center by ID
   * @returns {Promise<InvoiceCenterViewModel>}
   */
  async getInvoiceCenterByID(invoiceCenterID) {
    return await this.get(`invoiceCenter/${invoiceCenterID}`)
  }

  /**
   * Retrieves a list of overdue invoices grouped by Client/Group
   * @returns {Promise<OverdueInvoicesByClientInvoiceViewModel>}
   */
  async getOverdueInvoicesByClient(invoiceCenterID, dueDateUTC) {
    return await this.get(
      `overdueInvoices/byClient?invoiceCenterID=${invoiceCenterID}&dueDateUTC=${dueDateUTC}`
    )
  }

  /**
   * Generates a new invoice run containing new invoice charges
   * @param {GenerateOverdueInvoiceChargesDTO} dto
   * @returns {Promise<GenerateOverdueInvoiceChargesResult>}
   */
  async generateOverdueInvoiceCharges(payload) {
    return await this.post('overdueInvoices/generateCharges', payload)
  }

  async getInvoiceCenters() {
    return await this.get('invoiceCenter')
  }
}
